
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"81","height":"77","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".1","stroke":"#8F7A61","stroke-width":"5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M50 44H31v30h19V44z"}}),_c('path',{attrs:{"d":"M70 33v41H11V33"}}),_c('path',{attrs:{"d":"M3 40.734L40.603 3l37.593 37.734"}})])])
          )
        }
      }
    